module.exports = __webpack_public_path__ + "img/bg.2e26049d.webp";